import { render, staticRenderFns } from "./BannerHeroCreate.vue?vue&type=template&id=1129b414&"
import script from "./BannerHeroCreate.vue?vue&type=script&lang=js&"
export * from "./BannerHeroCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports